import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RenaultAnimationActionGoalMatrixDTO, RenaultAnimationActionGoalMatrixGlobalDTO } from '../../../models/renault-animation-action-dto';
import { AnimationActionService } from '../../../services/animation-action.service';

@Component({
  selector: 'animation-action-goal-global-matrix',
  templateUrl: './animation-action-goal-global-matrix.component.html',
  styleUrls: ['./animation-action-goal-global-matrix.component.scss']
})
export class AnimationActionGoalGlobalMatrixComponent implements OnInit {

  @Input() idAction: string;

  model: RenaultAnimationActionGoalMatrixGlobalDTO;
  activeId;
  constructor(public activeModal: NgbActiveModal,
    private service: AnimationActionService) { }

  ngOnInit(): void {


    this.service.getAnimationActionGoalMatrixRenaultZone(this.idAction).subscribe(resp => {
      this.model = resp;
      
    });



  }

}
